import { render } from "./QuestionActions.vue?vue&type=template&id=448a0030&ts=true"
import script from "./QuestionActions.vue?vue&type=script&lang=ts"
export * from "./QuestionActions.vue?vue&type=script&lang=ts"

import "./QuestionActions.vue?vue&type=style&index=0&id=448a0030&lang=sass"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__